export enum eTaxType {
  mortgage = 'mortgage',
  deed = 'deed',
  excise = 'excise',
}

export const prettyTaxType: Record<eTaxType, string> = {
  [eTaxType.deed]: 'Deed',
  [eTaxType.mortgage]: 'Mortgage',
  [eTaxType.excise]: 'Excise',
};
